module.exports = __webpack_public_path__ + "img/plan.dfd9dfd6.png";